import { render, staticRenderFns } from "./DashboardOpef.vue?vue&type=template&id=52fc1db6&"
import script from "./DashboardOpef.vue?vue&type=script&lang=js&"
export * from "./DashboardOpef.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOpef.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports